import { useEffect, useContext } from "react";
import { mutate } from "swr";

import getBuyerAPIDomain from "../getBuyerAPIDomain";
import deleteSavedSearches from "../SavedSearches/api/deleteSavedSearches";
import { ParsedUrlQuery } from "querystring";
import { ErrorContext } from "../context/ErrorContext";
import analytics from "../common/analytics/analytics";
import { IEventPushable } from "../common/analytics/analytics.types";
import { StoreType } from "../StoreType";
import { useSelector } from "react-redux";
import { GET_STATE } from "../redux/slices/appSlice";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

export const useDeleteSavedSearches = (
  ids: Array<string>,
  setIds: (ids: Array<string>) => void,
  queryString: ParsedUrlQuery
) => {
  const errorContext = useContext(ErrorContext);

  const {
    app: { isToUseAuthZero },
  }: StoreType = useSelector(GET_STATE);
  const { accessToken } = useAuth(!isToUseAuthZero);

  const pushSavedSearchDeleteAnalytics = () => {
    analytics.push<IEventPushable>({
      event: {
        action: "delete-confirm",
        category: "button",
        label: "stock-alert",
        name: "click",
        section: "",
      },
    });
  };

  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
  const deleteSavedSearchResultsUrl = buyerAPIDomain
    ? new URL(`${buyerAPIDomain.href}/savedsearch`, buyerAPIDomain)
    : "";

  const savedSearchResultsUrl = buyerAPIDomain
    ? new URL(`${buyerAPIDomain.href}/savedsearch/list`, buyerAPIDomain)
    : null;

  if (savedSearchResultsUrl && queryString) {
    Object.keys(queryString).map((queryName) =>
      savedSearchResultsUrl.searchParams.append(
        queryName,
        queryString[queryName] as string
      )
    );
  }

  useEffect(() => {
    if (ids.length) {
      deleteSavedSearches(
        deleteSavedSearchResultsUrl,
        {
          savedSearchIds: ids,
        },
        accessToken,
        isToUseAuthZero
      )
        .then((success) => {
          if (success) {
            pushSavedSearchDeleteAnalytics();
            setIds([]);
            mutate(savedSearchResultsUrl.href);
          }
        })
        .catch((error) => {
          errorContext?.dispatch({ type: "delete-saved-searches" });
        });
    }
  }, [ids]);
};
